import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalHeader } from '../../components/ModalHeader';
import { useAuth } from '../../hooks/auth';
import { useModal } from '../../hooks/modal';
import { useToast } from '../../hooks/toast';
import { api } from '../../services/api';

import { Button, Content, Container, Text, ContainerText } from './styles';

interface IInfoNewGymProps {
  existingAccount?: boolean;
  gymName?: string;
}

const InfoNewGym: React.FC<IInfoNewGymProps> = ({
  existingAccount,
  gymName,
}) => {
  const { removeAllModals } = useModal();
  const { addToast } = useToast();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = useCallback(() => {
    addToast({
      title: `Redirecionando para login ...`,
      description: 'Insira os dados para continuar.',
    });

    navigate('/');
    signOut();
    removeAllModals();
  }, [addToast, navigate, removeAllModals, signOut]);

  return (
    <Container>
      <ModalHeader
        title={
          existingAccount ? 'Academia cadastrada' : 'Boas vindas a nossa plataforma'
        }
      />
      <Content>
        <ContainerText>
          {existingAccount ? (
            <>
              <Text>
                A academia <span>{gymName || 'nova'}</span> foi cadastrada e o
                seu usuário foi cadastrado como gestor dela.
              </Text>
              <Text>
                Esse email já tinha cadastro na plataforma -- não é uma conta
                nova. Para acessar as informações dessa academia, basta fazer
                login normalmente e selecionar o vínculo no{' '}
                <span>canto superior direito</span> da tela.
              </Text>
            </>
          ) : (
            <>
              <Text>
                <span>
                  A criação da sua academia e acesso do gestor foram
                  realizadas com sucesso.
                </span>
              </Text>
              <Text>
                Nesse momento, um <span>email</span> foi enviado a caixa de
                entrada do gestor cadastrado. Nele existem algumas orientações
                sobre o <span>período de teste</span> e uma{' '}
                <span>senha provisória</span> para o primeiro acesso a
                plataforma.
              </Text>
              <Text>
                Verifique também a <span>caixa de span</span>.
              </Text>
            </>
          )}
        </ContainerText>
        <Button
          name="signUp"
          value="Ir para login"
          onClick={() => handleSubmit()}
        />
      </Content>
    </Container>
  );
};

export { InfoNewGym };
